import axios from "axios";
import { getBackendUrl } from "../../config";
export const billingToken = () => sessionStorage.getItem("zapticket:billing") || "";
export const saveBillingToken = token => sessionStorage.setItem("zapticket:billing", token);
export const billingApi = axios.create({ baseURL: getBackendUrl(), withCredentials: true });
billingApi.interceptors.request.use(config => { const token = billingToken(); if (token) config.headers.Authorization = `Bearer ${token}`; return config; });
export const money = cents => (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
